<template>
	<div
		class="tickets-dashboard-graph-container"
		style="height: 400px; margin-top: -50px"
	>
		<div
			ref="ticketsLocationGraph"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
const echarts = require("echarts");
import ticketDashboardMixins from "../../../../../mixins/ticketDashboardMixins";
export default {
	name: "TicketsLocationGraph",
	mixins: [ticketDashboardMixins],
	data() {
		return {
			ticketLocationGraphInstance: "",
			// option: {
			//   color: ['#D26300', '#E29D5A', '#333333', '#F9CB9C'],

			//   tooltip: {
			//     trigger: 'axis',
			//     axisPointer: {
			//       type: 'shadow'
			//     }
			//   },
			//   grid: {
			//     right: '15%',
			//     y: 40,
			//     y2: 100,
			//   },
			//   // toolbox: {
			//   //   feature: {
			//   //     dataView: { show: true, readOnly: false },
			//   //     restore: { show: true },
			//   //     saveAsImage: { show: true }
			//   //   }
			//   // },
			//   legend: {
			//     data: ['Total Tickets', 'Closed Tickets', 'SLA %'],
			//     textStyle: {
			//       fontSize: '16',
			//     },
			//   },
			//   xAxis: [
			//     {
			//       type: 'category',
			//       axisTick: {
			//         alignWithLabel: true
			//       },
			//       // prettier-ignore
			//       data: ['East', 'West', 'North', 'South']
			//     }
			//   ],
			//   yAxis: [
			//     {
			//       type: 'value',
			//       // name: 'Within SLA',
			//       name: '',
			//       min: 0,
			//       max: 30,
			//       position: 'left',
			//       alignTicks: true,
			//       axisLine: {
			//         show: true,
			//         lineStyle: {
			//           color: '#333333'
			//         }
			//       },
			//       axisLabel: {
			//         formatter: '{value}'
			//       }
			//     },
			//     {
			//       type: 'value',
			//       // name: 'SLA Violation',
			//       name: '',
			//       min: 0,
			//       max: 30,
			//       position: 'left',
			//       alignTicks: true,
			//       offset: 80,
			//       axisLine: {
			//         show: true,
			//         lineStyle: {
			//           // color: '#E29D5A'
			//           color: 'transparent'
			//         }
			//       },
			//       axisLabel: {
			//         formatter: '{value}'
			//       }
			//     },
			//     {
			//       type: 'value',
			//       // name: 'SLA %',
			//       name: '',
			//       min: 0,
			//       interval: 25,
			//       max: 100,
			//       position: 'right',
			//       alignTicks: true,
			//       axisLine: {
			//         show: true,
			//         lineStyle: {
			//           color: '#333333'
			//         }
			//       },
			//       axisLabel: {
			//         formatter: '{value} %'
			//       }
			//     },
			//     {
			//       type: 'value',
			//       // name: 'Violation %',
			//       name: '',
			//       min: 0,
			//       interval: 25,
			//       max: 100,
			//       position: 'right',
			//       alignTicks: true,
			//       offset: 80,
			//       axisLine: {
			//         show: true,
			//         lineStyle: {
			//           // color: '#F9CB9C'
			//           color: 'transparent'
			//         }
			//       },
			//       axisLabel: {
			//         formatter: '{value} %'
			//       }
			//     },
			//   ],
			//   series: [
			//     {
			//       name: 'Total Tickets',
			//       type: 'bar',
			//       yAxisIndex: 0,
			//       barWidth: 20,
			//       data: [
			//         // 2.0, 4.9, 7.0, 23.2
			//       ]
			//     },
			//     {
			//       name: 'Closed Tickets',
			//       type: 'bar',
			//       yAxisIndex: 1,
			//       barWidth: 20,
			//       data: [
			//         // 2.6, 5.9, 9.0, 26.4
			//       ]
			//     },
			//     {
			//       name: 'SLA %',
			//       type: 'line',
			//       yAxisIndex: 2,
			//       lineStyle: {
			//         type: 'dashed',
			//         width: 3,
			//         gap: 0
			//       },
			//       data: [
			//         // 2.0, 2.2, 3.3, 4.5
			//       ]
			//     },
			//     // {
			//     //   name: 'Violation %',
			//     //   type: 'line',
			//     //   yAxisIndex: 3,
			//     //   lineStyle: {
			//     //     type: 'dashed',
			//     //     width: 2,
			//     //     gap: 0
			//     //   },
			//     //   data: [5.0, 22.2, 7.3, 9.5]
			//     // },
			//   ]
			// }
			option: {
				color: ["#D26300", "#E29D5A", "#333333", "#F9CB9C"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
				},
				grid: {
					right: "10%",
					containLabel: true,
				},
				legend: {
					data: ["Total Tickets", "Closed Tickets"],
					textStyle: {
						fontSize: 16,
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37,
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
							formatter: (value) => {
								if (value.includes("__")) {
									let labelArr = value.split("__");
									return `${this.excerptText(this.titleCase(labelArr[0]), 9)}\n
                        ${this.excerptText(this.titleCase(labelArr[1]), 9)}`;
								} else {
									return this.excerptText(value, 9);
								}
							},
						},
						boundaryGap: true,
						data: [],
						textStyle: {
							fontSize: "14",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "",
						min: 0,
						max: 30,
						position: "left",
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}",
						},
					},
					{
						type: "value",
						name: "",
						min: 0,
						interval: 25,
						max: 100,
						position: "right",
						offset: 80,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "", // Empty string to remove labels
							color: "#fff", // White color for labels
						},
					},
					{
						type: "value",
						name: "",
						min: 0,
						interval: 25,
						max: 100,
						position: "right",
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
					{
						type: "value",
						name: "",
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "", // Empty string to remove labels
							color: "#fff", // White color for labels
						},
					},
				],
				dataZoom: [
					{
						type: "slider",
						show: true,
						xAxisIndex: [0],
						start: 0,
						end: 100,
						bottom: 10,
						handleSize: "100%",
						showDetail: false, // Remove the labels on the left and right sides
						height: 10,
					},
				],
				series: [
					{
						name: "Total Tickets",
						barGap: "10%",
						barCategoryGap: "20%",
						type: "bar",
						groupPadding: 0,
						yAxisIndex: 0,
						showBackground: false,
						yAxisIndex: 0,
						barWidth: "25%",
						data: [2.0, 4.9, 7.0, 23.2],
					},
					{
						name: "Closed Tickets",
						barGap: "10%",
						barCategoryGap: "20%",
						type: "bar",
						groupPadding: 0,
						yAxisIndex: 0,
						showBackground: false,
						yAxisIndex: 1,
						barWidth: "25%",
						data: [2.6, 5.9, 9.0, 26.4],
					},
					// {
					// 	name: "SLA %",
					// 	type: "line",
					// 	yAxisIndex: 2,
					// 	lineStyle: {
					// 		type: "dashed",
					// 		width: 3,
					// 		gap: 0,
					// 	},
					// 	data: [2.0, 2.2, 3.3, 4.5],
					// },
				],
			},
		};
	},
	computed: {
		graphMaxInterVal() {
			let max = 50;
			if (this.ticket_data && this.ticket_data.length) {
				let totalTickets = this.ticket_data.map((el) => el.total);
				let closedTickets = this.ticket_data.map((el) => el.closed);
				let topTotalTickets = Math.max(...totalTickets);
				let topCloseTickets = Math.max(...closedTickets);
				if (topTotalTickets > topCloseTickets) {
					max = topTotalTickets;
				} else {
					max = topCloseTickets;
				}
			}
			max = this.roundNearestTen(max);
			return max;
		},
	},
	watch: {
		ticket_data(newValue, oldValue) {
			this.reRenderGraph(newValue);
		},
	},
	created() {
		setTimeout(() => {
			this.initGraph();
		}, 80);
	},
	methods: {
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		initGraph() {
			let chartContainer = this.$refs.ticketsLocationGraph;
			this.ticketLocationGraphInstance = echarts.init(chartContainer);
			this.ticketLocationGraphInstance.setOption(this.option);
			this.ticketLocationGraphInstance.showLoading();
		},

		reRenderGraph(data) {
			let locations = [];
			let totalTickets = [];
			let closedTickets = [];
			let slaPercentage = [];
			for (let i = 0; i < data.length; i++) {
				let item = data[i];
				locations.push(this.$options.filters.titleCase(item.name));
				totalTickets.push(item.total);
				closedTickets.push(item.closed);
				// slaPercentage.push(item.within_sla_percentage);
			}

			// x axis labels
			this.option.xAxis[0].data = locations; // Show only first 5 entries initially

			// Plotting Total Tickets data
			this.option.series[0].data = totalTickets;
			// Plotting Closed Tickets data
			this.option.series[1].data = closedTickets;
			// Plotting SLA Percentage data
			// this.option.series[2].data = slaPercentage;

			this.option.yAxis[0].max = this.graphMaxInterVal;
			this.option.yAxis[1].max = this.graphMaxInterVal;

			this.ticketLocationGraphInstance.clear();
			this.ticketLocationGraphInstance.setOption(this.option);
			this.ticketLocationGraphInstance.hideLoading();
		},
		roundNearestTen(num) {
			return Math.ceil(num / 5) * 5;
		},
	},
};
</script>
